// showjoke.js
const jokes = [
    "This site was going to be named UranusPictures.com",
    "Why did the astronaut break up with the comet? Because she felt like he was just going in circles.",
    "What's a black hole's favorite type of candy? A Milky Way.",
    "Why did the sun go to school? To shine brighter!",
"How do you throw a space party? You plan it!",
"What kind of music do planets like? Neptunes!",
"Why did Venus work at the restaurant? It had good cooking conditions!",
"Why don’t aliens eat clowns? Because they taste funny!",
"What do you call a tick on the moon? A luna-tick.",
"How does the moon cut its hair? It eclipses it.",
"Why was the math book sad? Because it had too many problems!",
"What do astronomers break up with? Their galaxy-friend.",
"What’s a spaceman’s favorite candy? A Milky Way.",
"How do you throw a space party? You rocket!",
"Why was the astronaut a good gardener? He had a green thumb… on the moon!",
"What does a baby computer call its father? Data!",
"Why did the star get arrested? For shining too bright.",
"What do planets read? Comet books!",
"Why was the moon so full? It had too much space cheese.",
"Why did the astronaut retire? He got spaced out.",
"What did Mars say to Saturn? Give me a ring sometime!",
"Why did the astronaut become an artist? He wanted to draw the atmosphere.",
"What do you call a spaceship that’s been sitting too long? A stationary!",
"Why don’t books start with a trip to space? They prefer starting on Earth.",
"How do you keep a bull from charging in space? Take away its credit card!",
"What do you call a nervous astronaut? An astro-not.",
"Why are moons bad at hide and seek? They always get spotted.",
"Why did the sun never go to college? It already had a million degrees!",
"Why couldn’t the astronaut book a hotel on the moon? It was all full!",
"What’s an alien’s favorite place on a computer? The big space button.",
"Why are astronauts calm? Because they have lots of space.",
"What do you call an explosive ape in space? A ba-boom!",
"How do you plan a welcome party in space? You plan it really well.",
"Why did the sun go to school? To shine even brighter!",
"Why was the belt arrested in space? For holding up an asteroid!",
"What does a space turkey say? “Hubble, hubble, hubble.”",
"Why don’t aliens start fights? They don’t want trouble in the universe.",
"Why don’t space parties run out of food? Because they always have a Milky Way.",
"What’s a spaceman’s favorite chocolate? Meteor Crunch.",
"How do you get a baby astronaut to sleep? You rock them gently!",
"What did the alien say to the cat? “Take me to your litter.”",
"Why are books about anti-gravity such good reads? Because you can’t stop reading them!",
"What did one comet say to the other? “You revolve around me.”",
"What do planets like to read? Comet books!",
"Why did the cow go in the spaceship? It wanted to see the mooooooon.",
"Why would a cow want to go to space? To see the Milky Way.",
"What do you call someone who’s NOT a vegetarian? A meteor.",
"Which is closer, Florida or the moon? The moon. You can’t see Florida from here.",
"Where can planets update their status? Their Space book account.",
"Where do planets download their music from? Nep-tunes.",
"Why did Mickey Mouse go to outer space? To find Pluto.",
"What kind of money is used for trade in outer space? Star bucks.",
"What did Jupiter say to Saturn? “I like you, give me a ring sometime.”",
"How do you start a fight in space? “Comet me, bro.”",
"Why did Venus dump Mars? She only wanted a pluto-nic relationship.",
"What was the first animal in space? The cow that jumped over the moon.",
"What do you get when you cross a lamb and a rocket? A space sheep!",
"What do you call the lights on a lunar rover? Moonbeams.",
"What’s the Sun’s favorite thing to drink? Solar-ade!",
"Why did the Sun go to school? To get a little brighter!",
"What does the Sun eat for breakfast? Sunshine cereal!",
"Why did the Moon get a job? It wanted to make some moon-ey!",
"How does the Moon cut its hair? Eclipse it!",
"Why did the Moon feel full? Because it had too many moon pies!",
"What’s the Sun’s favorite movie? A Star is Born!",
"Why did the Sun go to therapy? It had a solar meltdown!",
"What’s the Moon’s favorite song? “Fly Me to the Moon”!",
"Why did the Sun go to space? It needed a vacation!",
"How do you organize a space party? You planet!",
"Why does the Moon always seem so relaxed? Because it’s just going through its phases!",
"What do you call a sleepwalking Sun? A daydreamer!",
"Why did the Moon call in sick? It felt under the weather!",
"What’s the Sun’s favorite candy? Starburst!",
"You’re my space jam.",
"I love you to the moon and back.",
"You’re out of this world!",
"My love for you is astronomical.",
"You’re my star.",
"You’re the sun to my day.",
"You’re my favorite space cadet.",
"I’m over the moon for you.",
"You’re my universe.",
"We have a stellar connection.",
"You’re my shining star.",
"You’re my cosmic love.",
"You’re the rocket to my heart.",
];

function showJoke() {
    const randomIndex = Math.floor(Math.random() * jokes.length);
    return jokes[randomIndex];
}

export { showJoke, jokes };
